export default [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home "*/ '@/pages/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  { //for API auth redirect
    path: '/silent-refresh',
    name: 'silent-refresh',
    component: () => import(/* webpackChunkName: "home "*/ '@/components/global//loading/LoadingScreen.vue'),
    meta: {
      requiresAuth: false,
      ssoRedirect: true,
    },
  },
  { //for API auth redirect
    path: '/signin',
    name: 'signin',
    component: () => import(/* webpackChunkName: "home "*/ '@/components/global/loading/LoadingScreen.vue'),
    meta: {
      requiresAuth: false,
      ssoRedirect: true,
    },
  },
  { //for API auth redirect
    path: '/signout-callback',
    name: 'signout-callback',
    component: () => import(/* webpackChunkName: "home "*/ '@/components/global/loading/LoadingScreen.vue'),
    meta: {
      ssoRedirect: true,
      requiresAuth: false,
    },
  },
  {
    //for API auth redirect - guest users
     path: '/guest-signin',
     name: 'guest-signin',
     component: () => import(/* webpackChunkName: "home "*/ '@/components/global/loading/LoadingScreen.vue'),
     meta: {
       requiresAuth: false,
       ssoRedirect: true,
     },
   },
  {
    path: '/create-space',
    name: 'create-space',
    component: () => import(/* webpackChunkName: "account "*/ '@/pages/NewSpace.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/invite',
    name: 'space-invites',
    component: () => import(/* webpackChunkName: "account "*/ '@/pages/SpaceInvites.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/room/:roomId',
    name: 'room',
    component: () => import(/* webpackChunkName: "SpaceSettings "*/ '@/pages/RoomLobby.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/space/:areaId',
    name: 'area',
    // name: 'area',
    component: () => import(/* webpackChunkName: "Space "*/ '@/pages/SpaceLobby.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  // --------------------- NEED TO BE AT BOTTOM AS 'ELSE' ------------------------ //
  {
    path: '/space/:areaId/admin/manage-users',
    name: 'manage-users',
    component: () => import(/* webpackChunkName: "manageUsers "*/ '@/pages/ManageUsers.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/space/:areaId/admin/customise',
    name: 'customise',
    component: () => import(/* webpackChunkName: "SpaceSettings "*/ '@/pages/SpaceSettings.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404Page "*/ '@/pages/404Page.vue'),
    meta: {
      requiresAuth: true, //should go to login page if not logged in (redirect on 404 need auth)
    },
  }
];
